import {
    setTravellerValue,
    setErrorVisibility,
    setNumberOfRooms,
    openPartyDetailsOverlay,
    closePartyDetailsOverlay,
    setChildAge
} from './core';
import {fromJS, List, Map} from 'immutable';
import {sessionCache} from 'locache';

export const EMPTY_STATE = Map({
    rooms: List([
        Map({
            adults: 2,
            children: 0,
            childAges: List([])
        }),
        Map({
            adults: 2,
            children: 0,
            childAges: List([])
        })
    ]),
    numberOfRooms: 1,
    valid: false,
    dirty: false,
    partyDetailsOverlayOpen: false
});

let INITIAL_STATE = EMPTY_STATE;

if (sessionCache('partyDetails').get() !== null) {
    INITIAL_STATE = fromJS(JSON.parse(sessionCache('partyDetails').get()));
}

export default function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case 'SET_TRAVELLER_VALUE':
            return setTravellerValue(state, action.payload.type, action.payload.value, action.payload.roomIndex);

        case 'OPEN_PARTY_DETAILS_OVERLAY' :
            return openPartyDetailsOverlay(state);

        case 'CLOSE_PARTY_DETAILS_OVERLAY' :
            return closePartyDetailsOverlay(state, action.reset);

        case 'SET_NUMBER_ROOMS' :
            return setNumberOfRooms(state, action.payload.number);

        case 'SET_CHILD_AGE' :
            return setChildAge(state, action.payload.roomIndex, action.payload.childIndex, action.payload.age);

        case 'SET_ERROR_VISIBILITY' :
            return setErrorVisibility(state, action.payload.errorVisibility);
    }
    return state;
}
